import FormButton from "../Components/Buttons/FormButton";
import { useRef } from "react";
import "../assets/css/style.css";
import InputFiled from "../Components/FormTag/InputFiled";
import { useForm } from "react-hook-form";
import { PATTERN_ERR_MSG } from "../Shared/Helper/ValidationMessage";
import { DATE_REGEX } from "../Shared/Helper/Constant";

const ExportLayout = ({ handleClose }: { handleClose: () => void }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = () => {
    handleClose();
  };

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  class exportlayout {
    public fromDate: string;
    public toDate: string;
    /**
     *
     */
    constructor() {
      this.fromDate = "";
      this.toDate = "";
    }
  }
  const {
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<exportlayout>({});

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      console.log("File selected:", file.name);
      // Handle the file upload logic here
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="form px-3 pb-2">
        <div className=" mb-4">
          <h5 className="fw-normal">All 1240 Records</h5>
        </div>
        <div className="row">
          <div className="col-6">
            <label >Date From</label>
            <InputFiled
              type="date"
              tabIndex={2}
              register={register}
              name="expectedDate"
              pattern={{
                type: DATE_REGEX,
                message: PATTERN_ERR_MSG,
              }}
              className="form-control"
              placeholder="Enter Expected Date"
            />
          </div>
          <div className="col-6">
            <label>Date To</label>
            <InputFiled
              type="date"
              tabIndex={2}
              register={register}
              name="expectedDate"
              pattern={{
                type: DATE_REGEX,
                message: PATTERN_ERR_MSG,
              }}
              className="form-control"
              placeholder="Enter Expected Date"
            />
          </div>
        </div>

        <div className="d-flex justify-content-end mt-5 gap-2 align-items-center">
          <FormButton
            tabIndex={25}
            className="sph-btn me-2"
            handleClick={handleClose}
          >
            Download Records
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift"
            handleClick={handleClose}
          >
            Cancel
          </FormButton>
        </div>
      </form>
    </>
  );
};

export default ExportLayout;
